import React from 'react';

const ListenLive = () => {
    return (
        <>
            <iframe
                title="Listen Live"
                width="450"
                height="350"
                frameBorder="0"
                src="https://live365.com/embeds/v1/player/a96984?s=md&m=dark&c=mp3"
            />
        </>
    );
};

export default ListenLive;